import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.servicePointSettings.title',
    defaultMessage: 'Service points',
    description: 'title of the service point settings on the configuration page',
  },
  feedback: {
    servicePointSettingsUpdated: {
      id: 'pages.settings.general.servicePointSettings.feedback.servicePointSettingsUpdated',
      defaultMessage: 'Service points saved',
      description: 'feedback on the successful update of service point settings',
    },
    servicePointSettingsNotUpdated: {
      id: 'pages.settings.general.servicePointSettings.feedback.servicePointSettingsNotUpdated',
      defaultMessage: 'Service points could not be saved',
      description: 'feedback on the failed update of service point settings',
    },
  },
  display: {
    label: {
      id: 'properties.locations',
      defaultMessage: 'Locations',
      description: 'label of the locations display',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.servicePointSettings.editDrawer.title',
      defaultMessage: 'Edit service points',
      description: 'title of the edit service points settings drawer',
    },
    servicePoints: {
      label: {
        id: 'properties.servicePoints',
        defaultMessage: 'Service points',
        description: 'label of the service points field',
      },
    },
    name: {
      label: {
        id: 'properties.name',
        defaultMessage: 'Name',
        description: 'label of the name field',
      },
    },
    location: {
      label: {
        id: 'properties.location',
        defaultMessage: 'Location',
        description: 'label of the location field',
      },
    },
    openings: {
      label: {
        id: 'properties.openingTimes',
        defaultMessage: 'Opening times',
        description: 'label of the openings field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
